import { useState, useRef } from 'react';

const Feedback: React.FC = () => {
  const [fileName, setFileName] = useState<string | null>(null);
  const [isSending, setIsSending] = useState(false);
  const [sendStatus, setSendStatus] = useState<{ success: boolean, message: string } | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];

      if (selectedFile.size > MAX_FILE_SIZE) {
        setSendStatus({
          success: false,
          message: 'Файл слишком большой. Максимальный размер: 10MB.'
        });
        setFileName(null);
        e.target.value = ''; // Сбрасываем значение input
        return;
      }

      setFileName(selectedFile.name);
    } else {
      setFileName(null);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSending(true);
    setSendStatus(null);

    try {
      if (!formRef.current) return;

      const formData = new FormData(formRef.current);

      // Проверка наличия файла
      // Проверка наличия файла
      const fileInput = formRef.current.querySelector('input[type="file"]') as HTMLInputElement | null;

      // Проверка размера файла, только если файл выбран
      if (fileInput?.files && fileInput.files.length > 0 && fileInput.files[0].size > MAX_FILE_SIZE) {
        throw new Error('Файл слишком большой. Максимальный размер: 10MB.');
      }

      const hasFile = fileInput?.files && fileInput.files.length > 0;

      // Формируем данные для шаблона
      const templateData = {
        name: formData.get('name') as string,
        email: formData.get('email') as string,
        shortInfo: formData.get('shortInfo') as string,
        nameFile: fileInput?.files && fileInput.files.length > 0 ? fileInput.files[0].name : ''
      };

      // Добавляем дополнительные поля
      formData.append('to', 'turtton@yandex.ru');
      formData.append('subject', 'Новая заявка с сайта');
      formData.append('templateName', 'website-application');
      formData.append('templateData', JSON.stringify(templateData));

      // Удаляем текстовые поля, которые уже в templateData
      formData.delete('name');
      formData.delete('email');
      formData.delete('shortInfo');

      const response = await fetch('https://email.turtton.ru/api/send-email', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (result.success) {
        setSendStatus({
          success: true,
          message: 'Заявка отправлена!'
        });
        formRef.current.reset();
        setFileName(null);
      } else {
        throw new Error(result.error || 'Ошибка при отправке');
      }
    } catch (error) {
      setSendStatus({
        success: false,
        message: error instanceof Error && error.message.includes('большой')
          ? 'Файл слишком большой. Максимальный размер: 10MB.'
          : 'Ошибка при отправке. Попробуйте позже.'
      });
      console.log('Ошибка при отправке формы:', error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className='lg:w-[94%] mx-auto flex flex-col lg:flex-row lg:gap-10 -mt-10 lg:-mt-5 relative z-50'>
      <div className="flex flex-col lg:w-[70%]">
        <p className=" block lg:hidden font-bold font-play text-[22px] text-[#273167] text-center">
          Оставьте заявку и мы с Вами свяжемся!
        </p>
        <img src="/title/feedback.webp" alt="Feedback" className='w-[70%] lg:w-full self-center' />
      </div>
      <div className="w-full mx-auto p-3 2xl:p-6 bg-white rounded-lg">
        <p className=" hidden lg:block font-bold font-play text-[40px] 2xl:text-[50px] text-[#273167] text-center mb-6">
          Оставьте заявку и мы с Вами свяжемся!
        </p>
        {sendStatus && (
          <div className={`mb-6 p-4 rounded-lg text-xl ${sendStatus.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}>
            {sendStatus.message}
          </div>
        )}

        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="flex flex-col gap-3 lg:gap-5"
          encType="multipart/form-data"
        >
          <div className="flex gap-1 flex-col">
            <label htmlFor="name" className="block text-sm lg:text-xl font-medium text-[#6670A7] mb-1">
              Название компании/ИП
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="w-full px-2 lg:px-4 py-2 lg:py-4 text-sm lg:text-xl rounded-[3px] xl:rounded-lg focus:outline-none bg-[#F2F6FB] text-[#202856]"
              required
            />
          </div>

          <div className="flex gap-1 flex-col">
            <label htmlFor="shortInfo" className="block text-sm lg:text-xl font-medium text-[#6670A7] mb-1">
              Краткое описание запроса
            </label>
            <input
              type="text"
              id="shortInfo"
              name="shortInfo"
              className="w-full px-2 lg:px-4 py-2 lg:py-4 text-sm lg:text-xl rounded-[3px] xl:rounded-lg focus:outline-none bg-[#F2F6FB] text-[#202856]"
              required
            />
          </div>

          <div className="flex gap-1 flex-col">
            <label htmlFor="file" className="block text-sm lg:text-xl font-medium text-[#6670A7] mb-1">
              Прикрепите файл с вашим ТЗ/описание проекта/PRD
            </label>
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between border border-[#02136E] rounded-lg">
                <input
                  type="file"
                  id="file"
                  name="file"
                  className="hidden"
                  onChange={handleFileChange}
                />
                <label
                  htmlFor="file"
                  className="px-2 lg:px-4 py-2 lg:py-4 text-sm lg:text-xl bg-[#F2F6FB] text-center rounded-[3px] xl:rounded-lg cursor-pointer hover:bg-[#CFE6FF] w-full h-full text-[#202856]"
                >
                  {fileName ?
                    <div className="text-sm lg:text-lg text-[#37479F] font-play flex items-center gap-1 lg:gap-2">
                      <span>Выбран файл:</span>
                      <span className="font-medium">{fileName}</span>
                    </div>
                    : "Выберите файлы"}
                </label>
              </div>
              {/* {fileName && } */}
              <p className="text-[12px] lg:text-sm text-[#7C86BC]">Максимальный размер файла: 10MB</p>
            </div>
          </div>

          <div className="flex gap-1 flex-col">
            <label htmlFor="email" className="block text-sm lg:text-xl font-medium text-[#6670A7] mb-1">
              Почта
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full px-2 lg:px-4 py-2 lg:py-4 text-sm lg:text-xl rounded-[3px] xl:rounded-lg focus:outline-none bg-[#F2F6FB] text-[#202856]"
              required
            />
          </div>

          <p className="text-xs lg:text-xl text-[#7C86BC]">*Все поля обязательны для заполнения</p>

          <button
            type="submit"
            className="w-auto py-2 px-4 lg:py-5 disabled:opacity-60 lg:px-6 bg-[#37479F] text-white font-play font-semibold lg:font-bold text-sm lg:text-[28px] 2xl:text-3xl mb-10 rounded-[3px] lg:rounded-lg hover:bg-[#2F3E8B] transition duration-300 ease-in-out self-end"
            disabled={isSending}
          >
            {isSending ? 'Отправка...' : 'Отправить'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Feedback;